import { useTheme } from "@/theme/useTheme";

import utilitydeskLight from "@/assets/branding/utilitydesk-light.png";

interface CaseFlowLogoProps {
  className?: string;
  heightClass?: string;
}

function CaseFlowLogo({ className = '', heightClass = 'h-32' }: CaseFlowLogoProps) {
  const { theme } = useTheme();

  // Use same logo for both themes
  const logoSrc = utilitydeskLight;

  return (
    <img
      src={logoSrc}
      alt="UtilityDezk"
      className={`${heightClass} w-auto object-contain select-none ${className}`}
      draggable={false}
    />
  );
}

export default CaseFlowLogo;
